import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

const emailsUrl = "/api/v1/email";

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrl}/storeContactUs`, parameter);
}
export function doSubmitCreateAccountForm(parameter: SubmitCreateAccountFormApiParameter) {
    return post<SubmitCreateAccountFormApiParameter, void>(`${emailsUrl}/storeCreateAccountRequest`, parameter);
}

export interface SubmitCreateAccountFormApiParameter extends ApiParameter {
    emailTo?: string;
    existingAccount?: string;
    existingAccountNumber?: string;
    existingAccountLoginAdminFullName?: string;
    existingAccountLoginAdminEmail?: string;
    businessName?: string;
    businessType?: string;
    materialsItemsRequested?: string;
    firstName?: string;
    lastName?: string;
    role?: string;
    emailAddress?: string;
    address?: string;
    city?: string;
    stateName?: string;
    countryName?: string;
    postalCode?: string;
    phoneNumber?: string;
    faxNumber?: string;
    foundOurSite?: string;
    message?: string;
}
